module.exports = __webpack_public_path__ + "img/food.6a3fc6d2.png";